import { RichiestaPreventivoDto } from "@/api";
import Button from "@/elements/Button";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { RichiestaPreventivoDetailContent } from "./RichiestaPreventivoDetailContent";

export async function downloadRichiestaPdf(
  richiesta: RichiestaPreventivoDto,
  defaultFileName: string
) {
  if (!richiesta.filePdf || !richiesta.tokenRecupero) return;
  const response = await axios.get(
    `/api/richieste_preventivo/token/${richiesta.tokenRecupero}/file_pdf`,
    { responseType: "blob" }
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", richiesta.filePdf.fileName || defaultFileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
  window.URL.revokeObjectURL(url);
}

interface RichiestaPreventivoDetailDialogProps {
  open: boolean;
  richiesta: RichiestaPreventivoDto | null;
  onClose: () => void;
}

export function RichiestaPreventivoDetailDialog({
  open,
  richiesta,
  onClose,
}: RichiestaPreventivoDetailDialogProps) {
  const { t } = useTranslation();

  if (!richiesta) return null;

  const handleDownloadPdf = async () => {
    try {
      await downloadRichiestaPdf(
        richiesta,
        t("richiestaPreventivoDetailDialog.filePdfDefault")
      );
    } catch (error) {
      console.error(
        t("richiestaPreventivoDetailDialog.errori.downloadPdf"),
        error
      );
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <span>{t("richiestaPreventivoDetailDialog.titolo")}</span>
          {richiesta.filePdf && (
            <Button
              variant="outlined"
              size="small"
              color="primary"
              onClick={handleDownloadPdf}
              startIcon={<DownloadIcon />}
            >
              {t("richiestaPreventivoDetailDialog.azioni.scaricaPdf")}
            </Button>
          )}
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <RichiestaPreventivoDetailContent richiesta={richiesta} />
      </DialogContent>

      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          {t("azioni.chiudi")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
